export default __webpack_public_path__ + "static/media/DECRETO EXECUTIVO.6c05f82c.pdf";